import React from 'react';
import PropTypes from 'prop-types';
import SvgWrapper from './SvgWrapper';

const MolluscIcon = ({ innerColor, outerColor, ...props }) => {
  return (
    <SvgWrapper {...props}>
      <path
        d="M215.49 107.54c0 59.48-48.46 107.54-107.95 107.54C48.07 215.07 0 167.02 0 107.54 0 48.06 48.07 0 107.54 0c59.49 0 107.95 48.06 107.95 107.54z"
        fill={outerColor}
      />
      <path
        d="M187.12 83.51c-1.58-3.14-4.33-4.33-7.1-5.91-1.58-.78-3.54-1.57-4.33-2.36-.8-1.18-1.58-3.16-2.37-5.52-1.57-3.54-3.15-7.48-7.09-10.63-3.16-2.76-7.09-3.55-10.63-4.34-2.76-.39-5.13-1.18-7.09-1.97-1.97-1.18-3.95-2.75-5.92-4.73-3.55-3.15-7.47-6.69-12.6-7.88-4.73-1.58-9.85-.39-14.57.79-2.76.4-5.52 1.18-7.89 1.18s-5.12-.78-7.47-1.18c-5.13-1.18-9.86-2.36-14.97-.79-5.12 1.19-9.07 4.73-12.61 7.88-1.97 1.97-3.94 3.54-5.92 4.73-1.57.78-4.33 1.58-6.7 1.97-3.94.79-7.88 1.58-11.02 4.34-3.55 3.15-5.52 7.09-6.69 10.63-1.2 2.36-1.98 4.34-2.77 5.52-.79.79-2.36 1.58-4.33 2.36-2.37 1.58-5.52 2.76-7.09 5.91-1.97 3.95-1.18 8.28-.39 11.02.39 1.19.39 2.37.39 3.16-.79 7.1 1.18 14.18 6.3 20.87 4.34 5.92 9.86 11.43 15.37 16.16v.39c5.12 4.33 11.02 9.85 16.93 14.17 2.37 1.97 5.13 3.55 7.49 5.12l-5.12 8.28c-1.97 2.75-1.97 5.9-.78 8.66 1.57 2.75 4.72 4.32 8.27 4.32h62.25c3.53 0 6.69-1.57 8.26-4.32 1.19-2.76 1.19-5.91-.78-8.66l-5.12-8.28c2.36-1.58 5.12-3.15 7.49-5.12 5.9-4.33 11.82-9.45 16.95-14.17v-.39c5.51-4.73 11.41-10.24 15.76-16.16 4.71-6.7 6.68-13.78 5.9-20.87 0-.79.39-1.97.39-3.16.78-2.75 1.96-7.08-.4-11.02zM40.18 85.08c1.98-.79 4.33-2.37 5.91-4.34.4-.39.79-.78 1.19-1.18l33.87 47.26-40.97-41.74zm27.58-23.23c1.18-.39 2.36-.79 3.15-1.58 1.97-.79 3.55-1.97 5.12-3.55l17.73 67.76-26-62.63zm39.78 64.98l-4.72-76.4c1.58.38 3.15.38 4.72.38 1.58 0 3.16 0 4.74-.38l-4.74 76.4zm31.52-70.11c1.58 1.58 3.15 2.76 5.12 3.55.79.79 1.97 1.19 3.15 1.58l-26.01 62.63 17.74-67.76zm-5.13 70.11l33.89-47.26c.39.4.78.79 1.18 1.18 1.57 1.97 3.94 3.55 5.9 4.34l-40.97 41.74z"
        fill={innerColor}
      />
    </SvgWrapper>
  );
};

MolluscIcon.defaultProps = {
  outerColor: '#03b2c7',
  innerColor: '#fefefe',
};
MolluscIcon.propTypes = {
  ...SvgWrapper.propTypes,
  outerColor: PropTypes.string,
  innerColor: PropTypes.string,
};

export default MolluscIcon;
